<template lang="pug">
.box-container
  v-btn(icon, small, @click="previous()", title="previous")
    v-icon mdi-menu-left
  v-menu(offset-y)
    template(v-slot:activator="{ on }")
      .btn-title(v-on="on") {{ months[index] }}
    v-card(max-height="400", width="120")
      v-list.py-0(dense)
        v-list-item(
          v-for="(item, index) in months",
          :key="index",
          @click="selectIndex(index)"
        )
          v-list-item-content
            v-list-item-title {{ item }}
  v-btn(icon, small, @click="next()", title="next")
    v-icon mdi-menu-right
</template>

<script>
/**
 * Select a month from 2017/01 - Current month
 * return
 * Name: YYYY-MM
 * Range: begin (unix time), end (unix time)
 */
import moment from "moment-timezone";
import _ from "underscore";

export default {
  name: "MonthSelector",
  props: {
    startYear: { type: Number, default: 2017 },
    futureMonths: { type: Number, default: 0 },
  },
  data() {
    return { index: 0 };
  },
  computed: {
    months() {
      const endTime = moment().add(this.futureMonths, "month").endOf("month");
      const endYear = endTime.year();
      const endMonth = endTime.month() + 1;
      let year = this.startYear;
      let items = [];
      while (year < endYear) {
        _.each(_.range(1, 13), (m) => items.push(this.format(year, m)));
        year++;
      }
      let month = 1;
      while (month <= endMonth) {
        items.push(this.format(endYear, month));
        month++;
      }
      items.reverse();
      return items;
    },
  },
  mounted() {
    const year = moment().year();
    const month = moment().month() + 1;
    this.selectMonth(this.format(year, month));
  },
  methods: {
    format(year, month) {
      return year + "-" + String(month).padStart(2, "0");
    },
    previous() {
      if (this.index + 1 < this.months.length) {
        this.index += 1;
        this.selectIndex(this.index);
      }
    },
    next() {
      if (this.index != 0) {
        this.index -= 1;
        this.selectIndex(this.index);
      }
    },
    selectIndex(index) {
      this.index = index;
      const month = this.months[index];
      this.selectMonth(month);
    },
    // month: YYYY-MM
    selectMonth(month) {
      this.index = this.months.indexOf(month);
      const begin = moment(month, "YYYY-MM").startOf("month").valueOf();
      const end = moment(month, "YYYY-MM").endOf("month").valueOf();
      const range = { begin, end };
      this.$emit("select", {
        name: month, // format: YYYY-MM
        range, // { begin, end }
        month, // format: YYYY-MM
        begin, // unix time
        end, // unix time
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.box-container
  display: inline-flex
  flex-direction: row
  align-items: center
  border-radius: 6px
  border: 1px solid #e4e4e4
  background-color: white
</style>